/**
 * Páginas de aviso da suíte, fora das áreas (SPEC 4.0, 10.7): 404 e "Sem acesso" a uma área. O
 * título vai no `h1` da barra (como a toolbar das áreas) e o aviso no `main`, com `h2`.
 */
import { Compass, Lock } from 'lucide-react';
import { useEffect } from 'react';
import { ButtonLink } from '@/components/ButtonLink';
import { useSession } from '@/data/auth/session';
import { MAIN_ID } from '@/lib/a11y';
import styles from '../App.module.css';
import { BrandMark } from '../shell/BrandMark';
import { suitePageCopy } from './copy';
import local from './Launcher.module.css';
import { SuiteAccountMenu } from './SuiteAccountMenu';
import { useRemoveSplash } from './splash';

export function SuiteNotice({ kind, areaName }: { kind: 'not_found' | 'no_access'; areaName?: string }) {
  useRemoveSplash();
  const session = useSession();
  const c = kind === 'not_found' ? suitePageCopy.notFound : suitePageCopy.noAccess;
  useEffect(() => {
    document.title = suitePageCopy.documentTitle(c.title);
  }, [c.title]);
  const Icon = kind === 'not_found' ? Compass : Lock;
  return (
    <div className={local.screen}>
      <header className={local.bar}>
        <a href="/" className={local.brand} aria-label={suitePageCopy.shell.launcher}>
          <BrandMark size={28} />
          <span className={local.brandName} aria-hidden="true">
            {suitePageCopy.brand}
          </span>
        </a>
        <h1 className={local.noticeTitle}>{c.title}</h1>
        <span className={local.actions}>{session && <SuiteAccountMenu />}</span>
      </header>
      <main id={MAIN_ID} tabIndex={-1} className={local.main}>
        <section
          className={styles.state}
          aria-labelledby="suite-aviso"
          data-testid={kind === 'no_access' ? 'sem-acesso' : undefined}
        >
          <span className={styles.stateIcon} aria-hidden="true">
            <Icon size={28} strokeWidth={1.75} />
          </span>
          <h2 id="suite-aviso" className={styles.stateTitle}>
            {c.title}
          </h2>
          <p className={styles.stateText}>
            {kind === 'no_access' ? suitePageCopy.noAccess.text(areaName ?? '') : suitePageCopy.notFound.text}
          </p>
          <ButtonLink href={session?.home ?? '/'} variant="secondary" size="md">
            {c.action}
          </ButtonLink>
        </section>
      </main>
    </div>
  );
}
